var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvidence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44444 14H12.5556C13.3533 14 14 13.3533 14 12.5556V2.44444C14 1.6467 13.3533 1 12.5556 1H2.44444C1.6467 1 1 1.6467 1 2.44444V12.5556C1 13.3533 1.6467 14 2.44444 14ZM2.44444 14L10.3889 6.05556L14 9.66667M6.05556 4.97222C6.05556 5.57053 5.57053 6.05556 4.97222 6.05556C4.37391 6.05556 3.88889 5.57053 3.88889 4.97222C3.88889 4.37391 4.37391 3.88889 4.97222 3.88889C5.57053 3.88889 6.05556 4.37391 6.05556 4.97222Z",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvidence);
export default __webpack_public_path__ + "static/media/evidence.147de3817bf1717bcaa54a148fc7821d.svg";
export { ForwardRef as ReactComponent };